<script setup lang="ts">
import { type Notification as NotificationType } from '@/stores/notifications/store'
import Notification from './Notification.vue'

defineProps<{
  notifications: NotificationType[]
}>()

const emit = defineEmits<{
  (e: 'close', notification: NotificationType): void
}>()
</script>

<template>
  <TransitionGroup
    name="notification"
    tag="div"
    class="fixed top-[4rem] left-4 z-[99999] sm:left-auto right-4 gap-2 flex flex-col"
  >
    <Notification
      v-for="notification in notifications"
      :key="notification.id"
      v-bind="notification"
      data-test="toast-notification"
      :data-test-type="notification.type"
      @close="emit('close', notification)"
    />
  </TransitionGroup>
</template>

<style scoped lang="scss">
.notification-move, /* apply transition to moving elements */
.notification-enter-active,
.notification-leave-active {
  transition: all 0.5s ease;
}

.notification-enter-from,
.notification-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* ensure leaving items are taken out of layout flow so that moving
   animations can be calculated correctly. */
.notification-leave-active {
  position: absolute;
}
</style>
